import { Button, FormGroup, Label, Input, Form, FormFeedback } from 'reactstrap';
import './autorizacao-laudar.styles.css';
import React from 'react';

const AutorizacaoLaudarPage = (props) => (<div className="mv-fade" role="dialog" >
    <div className="mv-autorizacao-box" >
        <div className="mv-autorizacao-logo">
            <img src={require('./logo.png')} alt="MV Sistemas" />
        </div>
        <div className="mv-autorizacao-sistema">
            O login de um médico <span>titular</span> é nescessário para concluir o laudo
        </div>
        <div className="mv-autorizacao-form">
            <Form>
                <FormGroup>
                    <Label for="usuario">Usuário</Label>
                    <Input invalid={!props.usuario_valido} type="text" name="usuario" id="usuario" required onChange={props.onChange} />
                    <FormFeedback>Usuário Inválido</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label for="senha">Senha</Label>
                    <Input invalid={!props.senha_valido} type="password" name="senha" id="senha" required
                        onChange={props.onChange} onKeyPress={(event) => {
                            if (event.key === "Enter") {
                                props.loginAutorizar();
                            }
                        }}
                    />
                    <FormFeedback>Senha Inválida</FormFeedback>
                </FormGroup>
                <br />
                <div style={{ display: 'block-inline'}}>
                    <Button color="primary" onClick={props.loginAutorizar}>Login</Button>
                    <Button color="secondary" onClick={props.fecharTela}>Fechar</Button>
                </div>
                <a className="mv-senha-link" href="/">Esqueceu a senha?</a>
            </Form>
        </div>
    </div>
</div>)

export default AutorizacaoLaudarPage;


// WEBPACK FOOTER //
// ./src/app/common/autorizacaoLaudar/autorizacao-laudar.page.js